import { LoadingScreen } from "@/components/layout/Loading";
import { Button } from "@/components/ui/button";
import ImageSvg from "@/components/ui/image-svg";
import { Input } from "@/components/ui/input";
import { toast } from "@/components/ui/use-toast";
import { changePassword } from "@/services/clientAreaService";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

function isValidPassword(password: string) {
  return /^(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,16}$/.test(
    password
  );
}

export default function CreateNewPassword() {
  const { email = "" } = useParams();
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!password || !repeatPassword) {
      toast({
        title: "Erro",
        description: "Preencha todos os campos.",
        variant: "destructive",
        style: {
          position: "fixed",
          top: 24,
          right: 24,
          zIndex: 9999,
          maxWidth: 400,
          width: "100%",
        },
      });
      return;
    }
    if (password !== repeatPassword) {
      toast({
        title: "Erro",
        description: "As senhas não coincidem.",
        variant: "destructive",
        style: {
          position: "fixed",
          top: 24,
          right: 24,
          zIndex: 9999,
          maxWidth: 400,
          width: "100%",
        },
      });
      return;
    }
    if (!isValidPassword(password)) {
      toast({
        title: "Erro",
        description:
          "A senha deve ter entre 8 e 16 caracteres, conter pelo menos um número e um caractere especial.",
        variant: "destructive",
        style: {
          position: "fixed",
          top: 24,
          right: 24,
          zIndex: 9999,
          maxWidth: 400,
          width: "100%",
        },
      });
      return;
    }

    setLoading(true);
    try {
      const response = await changePassword(email, password);
      if (response?.Sucesso) {
        toast({
          title: "Sucesso!",
          description: "Senha alterada com sucesso.",
          variant: "green",
          style: {
            position: "fixed",
            top: 24,
            right: 24,
            zIndex: 9999,
            maxWidth: 400,
            width: "100%",
          },
        });
        navigate("/login");
      } else {
        toast({
          title: response?.titulo || "Erro",
          description: response?.mensagem || "Erro ao alterar senha.",
          variant: "destructive",
          style: {
            position: "fixed",
            top: 24,
            right: 24,
            zIndex: 9999,
            maxWidth: 400,
            width: "100%",
          },
        });
      }
    } catch (error: unknown) {
      const err = error as { response?: { data?: { mensagem?: string } } };
      toast({
        title: "Erro",
        description:
          err?.response?.data?.mensagem || "Erro ao alterar senha.",
        variant: "destructive",
        style: {
          position: "fixed",
          top: 24,
          right: 24,
          zIndex: 9999,
          maxWidth: 400,
          width: "100%",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingScreen />;

  return (
    <div className="min-h-screen px-5 py-10 md:px-10 md:py-20">
      <div className="flex flex-col md:flex-row items-center justify-center gap-10">
        <div className="bg-white max-w-[600px] rounded-[20px] w-full md:w-1/2 flex flex-col items-center justify-center px-10 space-y-8 py-12">
          <h1 className="text-4xl md:text-5xl font-bold text-center text-n-text-green">
            Criar nova senha
          </h1>
          <p className="text-md md:text-lg text-center text-n-text-neutral max-w-md">
            A senha deve ter entre 8 e 16 caracteres, incluindo pelo menos um
            número e um caractere especial (como !, @, #).
          </p>

          <form
            onSubmit={handleSubmit}
            className="w-full flex flex-col gap-6 max-w-xl"
          >
            <Input
              type="password"
              placeholder="Nova senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full h-14 text-base px-6 rounded-xl border border-n-neutral-lighter bg-white"
            />
            <Input
              type="password"
              placeholder="Repetir nova senha"
              value={repeatPassword}
              onChange={(e) => setRepeatPassword(e.target.value)}
              required
              className="w-full h-14 text-base px-6 rounded-xl border border-n-neutral-lighter bg-white"
            />
            <div className="flex justify-end w-full">
              <Button
                type="submit"
                className="w-full md:w-[250px] h-12 rounded-full bg-n-green-action hover:brightness-95 text-n-text-green text-base font-semibold"
              >
                Enviar
                <span className="ml-2">→</span>
              </Button>
            </div>
          </form>
        </div>

        <div className="w-full md:w-1/2 flex items-center justify-center">
          <ImageSvg
            src={"concept-company.svg"}
            alt="Criar nova senha"
            className="w-[320px] md:w-[600px] max-w-full"
          />
        </div>
      </div>
    </div>
  );
}
